<template>
  <footer class="footer">
    <v-container fluid>
      <v-layout wrap>
        <v-flex class="column">
          <h5 class="title">¿Querés enterarte de lo último?</h5>
          <p class="text">
            Recibí todas nuestras noticias, promociones y otras ventajas
            exclusivas.
          </p>
        </v-flex>
        <v-flex class="column">
          <div class="inline">
            <b-form-group>
              <b-form-input
                title="Ingresá a tu e-mail"
                class="input-text re querid-entry validate-email"
                placeholder="Ingresá tu e-mail"
                v-model="email"
              ></b-form-input>
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              class="button"
              @click="onSubscribe()"
              >Suscribirme</b-button
            >
          </div>
        </v-flex>
        <v-flex class="column">
          <h5><a class="route-name" href="/home">Inicio</a></h5>
          <h5><a class="route-name" href="/products"> Productos</a></h5>
          <h5><a class="route-name" href="/contact">Contacto</a></h5>
        </v-flex>
      </v-layout>
    </v-container>
  </footer>
</template>

<script>
import firebase from "firebase/firebase";
import { db } from "../firebase";

export default {
  mixins: [],
  name: "Footer",
  firebase: {
    customers: db.ref("customers"),
  },
  props: {},
  data() {
    return {
      email: "",
      customers: [],
    };
  },
  computed: {},
  methods: {
    onSubscribe() {
      let cust = this.customers.filter((t) => t.email === this.email);
      if (cust === null || cust === undefined || cust.length === 0) {
        db.ref("customers").push({
          email: this.email,
        });
        this.email = "";
      }
    },
  },
};
</script>

<style scoped>
.footer {
  padding-left: 20px;
  padding-right: 20px;
  bottom: 0;
  width: 100%;
  min-height: 8em;
  background-color: #f0f0f0;
  height: min-content;
  line-height: 100px;
  text-align: center;
}
.column {
  color: black;
  font-size: 18px;
  font-family: sans-serif;
}
.title {
  color: rgb(9, 8, 9);
  font-family: "Playfair Display";
}
.text {
  line-height: normal;
  font-size: 14px;
  padding-left: 10%;
  padding-right: 10%;
  font-family: "Roboto";
}
.button {
  color: black;
  background: white;
  border-color: white;
  height: 2em;
  line-height: 0 !important;
  margin-left: 1em;
  font-family: "Roboto";
}
.inline {
  display: inline-flex;
  width: 100%;
  font-family: "Roboto";
}
.form-control {
  margin-left: 1em;
  width: 20em;
}
.route-name {
  color: rgb(9, 8, 9);
}

@media only screen and (max-width: 600px) {
  .footer {
    padding-left: 0px;
    padding-right: 0px;
  }
  .form-control {
    margin-left: 0em;
    width: 15em;
    font-size: 14px;
  }
  .button {
    font-size: 15px;
    margin-top: 2px;
  }
  .text {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue